import sanityClient from '@sanity/client'

export const config = {
  projectId: process.env.GATSBY_SANITY_PROJECT_ID,
  dataset: process.env.GATSBY_SANITY_DATASET,
  useCdn: true
}

export const client = sanityClient(config)
